import { useState } from 'react';
import './Login.css';
import { useDispatch } from 'react-redux';
import { login } from '../../features/login/loginSlice.js';
import api from '../../api';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError('Inserisci email e password');
            return;
        }
        setLoading(true);
        setError(null);

        const data = { email, password };
        fetch(`${api()}/users/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            setLoading(false);
            if (data.messaggio === 'OK' || data.token) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('email', data.email || email);
                dispatch(login());
            } else {
                setError(data.messaggio || 'Credenziali non valide');
            }
        })
        .catch((err) => {
            setLoading(false);
            setError('Errore di connessione al server');
            console.error('Error:', err);
        });
    };

    return (
        <div className="login-wrapper">
            <div className="login-background-glow"></div>
            <div className="login-card">
                <div className="login-header">
                    <div className="login-brand-badge">R42</div>
                    <h2>Risposta42</h2>
                    <p>Dashboard Progetti & Gestione Dev</p>
                </div>

                {error && <div className="login-error-alert">{error}</div>}

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <label htmlFor="email">Email Sviluppatore</label>
                        <div className="input-with-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                            <input 
                                id="email"
                                type="email" 
                                autoComplete="username"  
                                placeholder="name@company.com"
                                value={email} 
                                onChange={(e) => setEmail(e.target.value)} 
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div className="input-with-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                            <input 
                                id="password"
                                type="password" 
                                autoComplete="current-password"
                                placeholder="••••••••" 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                            />
                        </div>
                    </div>

                    <button type="submit" className="login-btn-submit" disabled={loading}>
                        {loading ? 'Autenticazione in corso...' : 'Accedi al Sistema'}
                    </button>
                </form>
            </div>
        </div>
    );
}

